var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "pointer inline-block",
      class: {
        "text-left": _vm.align === "left",
        "text-center": _vm.align === "center",
        "text-right": _vm.align === "right",
      },
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.label))]),
      _c(
        "el-tooltip",
        { attrs: { effect: "dark", content: _vm.content, placement: "top" } },
        [_c("i", { staticClass: "el-icon-info margin-left-5" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }